import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { RounderUtil } from 'utils'

const CantidadFormGroup = ({ iError, iTouched, fIsSubmitting, vPrecio, setFieldValue, handleChange }) => {
  const onChange = React.useCallback(
    e => {
      handleChange(e)

      const valorStr = e.target.value
      const valorNumero = parseFloat(valorStr || '0')

      const total = RounderUtil.round(valorNumero * vPrecio)
      setFieldValue('total', total)
    },
    [setFieldValue, vPrecio, handleChange]
  )

  return (
    <Form.Group>
      <Form.Label text='CANTIDAD' htmlFor='producto-adicional-select-cantidad' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='cantidad'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='producto-adicional-select-cantidad'
              onChange={onChange}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CantidadFormGroup)
